import React from "react";
import { Link } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const BuildVersion: React.FC = () => {
  const version = __APP_VERSION__;
  const label = __APP_LABEL__;
  const build = __APP_BUILD__;
  const date = __APP_BUILD_DATE__;

  const display = `v${version}${label ? ` ${label}` : ""} · ${build}`;
  const tooltip = `Version ${version}${label ? ` ${label}` : ""}\nBuild ${build}\n${new Date(date).toLocaleString()}`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to="/changelog"
            className="text-white/60 hover:text-white transition-colors text-xs sm:text-sm font-mono tracking-tight select-none px-2"
            aria-label={`Build ${display} — view changelog`}
          >
            {display}
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <pre className="text-xs whitespace-pre-wrap">{tooltip}</pre>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default BuildVersion;
